import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AppGridComponent } from '../../shared/grid/grid-component/grid-component';
@Component({
  selector: 'app-show-grid-data',
  templateUrl: './show-grid-data.component.html',
  styleUrls: ['./show-grid-data.component.scss'],
})
export class ShowGridDataComponent implements AfterViewInit, OnChanges {
  @Input() gridData: any = [];
  gridDataForGrid: any = [];
  @Input() gridColumnDefs: any =[];
  @Input() showKebabIcon: any;
  @Input() gridConfigItems: any = {};
  @Input() loadMoreBinder: any;
  @Input() parentComponentName: any;
  @Input() searchText: any;
  @Output() onGridCellClick = new EventEmitter<any>();
  @Output() onSearch = new EventEmitter<any>();
  @Output() onAddBtnClick = new EventEmitter<any>();
  @ViewChild(AppGridComponent) gridComponent: AppGridComponent;
  private hasAppliedInitialData = false;
  private hasViewInitialized = false;

  constructor() { }

  ngAfterViewInit() {
    this.hasViewInitialized = true;
    this.fnInitialiseGrid();

    if (!this.hasAppliedInitialData) {
      this.replaceGridData(this.gridData);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.gridColumnDefs || changes.gridConfigItems) {
      this.hasAppliedInitialData = false;

      if (this.hasViewInitialized) {
        this.fnInitialiseGrid();
        this.replaceGridData(this.gridData);
      }
    }

    if (changes.gridData && changes.gridData.currentValue) {
      const updatedValue = changes.gridData.currentValue;
      this.gridData = updatedValue;

      if (!this.hasAppliedInitialData) {
        this.gridDataForGrid = updatedValue;

        if (this.hasViewInitialized) {
          this.replaceGridData(updatedValue);
        }
      }
    }
  }

  fnInitialiseGrid()
  {
    setTimeout(() => {
      this.gridComponent?.initializeGrid(false);
    }, 100);
  }

  public replaceGridData(data: any[] = []) {
    this.gridData = Array.isArray(data) ? data : [];
    this.gridDataForGrid = this.gridData;
    this.hasAppliedInitialData = true;

    setTimeout(() => {
      this.gridComponent?.fnReplaceAllDataInGrid(this.gridData);
    }, 100);
  }

  public appendGridData(data: any[] = []) {
    const incoming = Array.isArray(data) ? data : [];
    this.hasAppliedInitialData = true;

    setTimeout(() => {
      this.gridComponent?.fnAppendAllDataInGrid(incoming);
    }, 100);
  }

  handleCellClick(event: any) {
    this.onGridCellClick.emit(event);
  }

  handleSearchTextChange(event: any) {
    this.onSearch.emit(event);
  }

  handleAddBtnClick(event: any) {
    this.onAddBtnClick.emit(event);
  }

}
